'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdAddAlert = function MdAddAlert(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm26.6 21.7v-3.3h-5v-5h-3.2v5h-5v3.3h5v5h3.2v-5h5z m4.9 6.3l3.5 3.6v1.8h-30v-1.8l3.5-3.6v-9.6c0-5.4 3.8-10 8.8-11.2v-1.2c0-1.5 1.2-2.6 2.7-2.6s2.7 1.1 2.7 2.6v1.2c5 1.2 8.8 5.8 8.8 11.2v9.6z m-14.8 7h6.6c0 1.8-1.5 3.4-3.3 3.4s-3.3-1.6-3.3-3.4z' })
        )
    );
};

exports.default = MdAddAlert;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/add-alert.js
// module id = 1159
// module chunks = 168707334958949